module.exports = __webpack_public_path__ + "img/RN.afcbdfd3.png";